export default function formatLocaleString(string) {
  if (string === null) {
    return '';
  }
  return string.toLocaleString();
}
